import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BannerConfigModel } from '../../../models/section-configuration.model';
import { DateRangeValidator } from '../../../validators/date-range-validator.directive';
import { BannerVisibility } from 'src/app/modules/shared/models/banners-config.model';

@Component({
    selector: 'banner-config',
    templateUrl: 'banner-config.component.html',
    styleUrls: ['banner-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BannerConfigComponent implements OnInit {
  @Input() bannerConfig: BannerConfigModel;
  @Input() parentFormGroup: FormGroup;

  @Output() deleteBannerClicked: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  showBannerPreview: boolean = false;
  bannerVisibilityEnum = BannerVisibility;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  toggleBannerPreview(): void {
    this.showBannerPreview = !this.showBannerPreview;
  }

  deleteBanner(event: Event): void {
    event.preventDefault();
    this.deleteBannerClicked.emit(this.parentFormGroup);
  }

  fileChanged(file: File): void {
    this.bannerConfig.file = file;
  }

  private addControls(): void {
    this.parentFormGroup.addControl('src', new FormControl({ value: this.bannerConfig.src, disabled: true }));
    this.parentFormGroup.addControl('name', this.fb.control(this.bannerConfig.name));
    this.parentFormGroup.addControl('appId', this.fb.control(this.bannerConfig.appId));
    this.parentFormGroup.addControl('link', this.fb.control(this.bannerConfig.link));
    this.parentFormGroup.addControl('startDate', this.fb.control(this.bannerConfig.startDate));
    this.parentFormGroup.addControl('endDate', this.fb.control(this.bannerConfig.endDate));
    this.bannerConfig.visibility = this.bannerConfig.visibility ?? BannerVisibility.all;
    this.parentFormGroup.addControl('visibility', this.fb.control(this.bannerConfig.visibility));
    this.parentFormGroup.addControl('availableInCountries', this.fb.control(this.bannerConfig.availableInCountries));

    const dateRangeValidator = new DateRangeValidator();
    this.parentFormGroup.addValidators(dateRangeValidator.validateNotRequiredDateRange('startDate', 'endDate'));
    this.parentFormGroup.updateValueAndValidity({ emitEvent: false });
  }
}
